









































import Vue from 'vue';
import { capitalize, find } from 'lodash';

import ColumnTitle from '@/components/object_mapper/ColumnTitle.vue';
import SearchableList from '@/components/object_mapper/SearchableList.vue';
import SelectItem from '@/components/object_mapper/list_items/SelectItem.vue';

export default Vue.extend({
  name: 'Sidebar',
  components: {
    ColumnTitle,
    SearchableList,
    SelectItem,
  },
  props: {
    programId: {
      type: String,
      required: true,
    },
    selectedItem: {
      type: Object,
      default: null,
    },
    scoping: {
      type: String,
      required: true,
    },
    parentObjectType: {
      type: String,
      required: true,
    },
  },
  computed: {
    items() {
      if (!this.sidebarData) {
        return [];
      }
      return this.sidebarData[this.typeInSidebar];
    },
    typeInSidebar(): string {
      return {
        standards: 'programs',
        sections: 'standards',
        objectives: 'sections',
      }[this.scoping];
    },
  },
  apollo: {
    sidebarData: {
      query: require('../queries/SidebarData.gql'),
      variables() {
        return { programId: this.programId };
      },
      update: result => {
        const getMappedFromResponse = (objectType: string) =>
          result.node.mappings[objectType].edges.map(e => e.node).filter(n => n.status.value === 'In Scope');

        return {
          programs: [
            {
              id: result.node.id,
              dbId: result.node.dbId,
              title: result.node.title,
              __typename: result.node.__typename,
            },
          ],
          standards: getMappedFromResponse('standards'),
          sections: getMappedFromResponse('sections'),
        };
      },
    },
  },
  watch: {
    items(newValue: any[]) {
      if (newValue.length === 0) return;

      const newSelection = find(newValue, this.selectedItem) || newValue[0];
      this.$emit('selectItem', newSelection);
    },
  },
  methods: {
    capitalize,
  },
});
